// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Qendër e të dhënave",
        "pull_refresh": "Tërhiqeni për të rifreskuar",
        "release_refresh": "Lëshimi për të rifreskuar",
        "refresh_loading": "Duke u ngarkuar",
        "footer_text": "Shërbimet janë furnizuar nga Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Vendi/rajoni i kërkimit",
        "my_flow": "Të dhënat e mia",
        "charge_code": "Kodin e kuponit",
        "coupons": "Kuponë",
        "local_package": "Të dhëna lokale",
        "more": "Më",
        "popular_destination": "Vend/rajon",
        "buy_now": "Blej tani",
        "package_useing": "Aktiv",
        "unused": "Joaktiv",
        "download_app": "Shkarkoni APP",
        "enter_the_mall_list": "Futuni në listën e qendrës tregtare",
        "no_data": "Ende nuk ka të dhëna",
        "no_data_available": "Nuk ka të dhëna të disponueshme",
        "copy_success": "Kopjimi me sukses",
        "copy_fail": "Kopjimi dështoi",
        "meritsTitle": "Çfarë avantazhe kanë?",
        "merits1": "Pa SIM i nevojshëm & Pa tarifë mujore",
        "merits2": "Integruar me top 2-3 operatore për zëvendësim automatik të rrjetit",
        "go_buy": "Shko për të blerë",
        "instant_savings": "Kurseni",
        "expires_in": "Skadon në",
        "download_app_tips": "Shkarkoni aplikacionin për më shumë ofertat dhe përvoja"
    },
    "packages": {
        "sub_title": {
            "us": "Duke përjashtuar Guam, Saipan",
            "it": "Përfshirë Vatikanin e Vatikanit, San Marino",
            "va": "Përfshirë Italinë, San Marino",
            "sm": "Përfshirë Italinë, Qytetin e Vatikanit",
            "ma": "Përfshirë Sahara Perëndimore",
            "eh": "Përfshirë Marokun",
            "ch": "Përfshirë Lihtenshtajnin",
            "li": "Përfshirë Zvicrën",
            "fr": "Përfshirë Monaco",
            "mc": "Përfshirë Francën",
            "fi": "Përfshirë Ishujt Aland",
            "ax": "Përfshirë Finlandën",
            "gu": "Përfshirë Ishujt Mariana Veriore",
            "mp": "Përfshirë Guam"
        },
        "unlimited_packages": "Paketa e Pafund e të Dhënave",
        "normal_packages": "Paketë normale e të dhënave",
        "multi_region_packages": "Me shumë rajon",
        "regional_data": "Të dhëna rajonale",
        "high_speed_text": "Të dhëna me shpejtësi të lartë",
        "infiniteFlow": "Të dhëna të pakufizuara",
        "unLimitData": "E Pambrojtur",
        "high_speed_text_year": "Shpejtësia e lartë/MP",
        "package_list": "Lista e paketave",
        "special_offer": "Zbritje",
        "first_month": "1. Muaj",
        "periodUnit": {
            "day": "Dita (S)",
            "month": "muaj",
            "hour": "Ora (S)",
            "year": "vit"
        },
        "periodUnits": {
            "day": "Dita (S)",
            "month": "muaj",
            "hour": "Ora (S)",
            "year": "vite"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "për",
            "hour": "h",
            "year": "yr"
        },
        "periodUnitMonthly":"Muajsh",
        "periodUnitsSimp": {
            "day": "d",
            "month": "për",
            "hour": "h",
            "year": "yr"
        },
        "unlimited_good_name": {
            "day": "Kalim ditor",
            "month": "Kalim mujor",
            "year": "Kalim vjetor"
        },
        "continuousMonth": "Muaj të vazhdueshëm",
        "continuousDay": "Ditë të vazhdueshme",
        "continuousYear": "Vite të vazhdueshme",
        "day_invalid": "Skadojnë ditën e tanishme",
        "month_invalid": "Skadojnë në muajin aktual",
        "immediate_valid": "Efektive menjëherë",
        "tomorrow_day_valid": "Efektive nga dita tjetër",
        "tomorrow_month_valid": "Efektive nga muaji tjetër",
        "detail": {
            "cell_flow": "Të dhëna",
            "cell_period": "Vlefshmëri",
            "buy_quantity": "Sasi",
            "use_area": "Mbulim",
            "use_intro": "Kushtet dhe kushtet",
            "buy_btn": "Urdhër",
            "pay": "Paguaj",
            "buy_tips": "Ke paketën %@packageName në përdorim. A doni të bleni këtë paketë?",
            "haveOrderTips": "Porosi me pagesë në pritje të krijuar. Klikoni Konfirmo për të shkuar në faqen time të të dhënave！"
        },
        "confirm": {
            "title": "Konfirmimi i Rendit",
            "real_pay_amount": "Shuma e paguar",
            "online_payment": "Pagesë në internet",
            "create_order_error": "Konfigurimi dështoi"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Marrja e statusit të porosisë",
            "buy_success": "Porositni përfundimisht",
            "buy_pending": "Konfirmimi në pritje",
            "buy_pending_tip": "Pagesa në proces... nëse pagesa nuk u transferua brenda 10 minutave, ju lutemi na kontaktoni për mbështetje.",
            "get_payment_info_fail": "Blerja e informacionit të pagesës dështoi",
            "cell_package": "Pako",
            "cell_buy_amount": "I hollësishëm",
            "cell_real_amount": "Shuma e paguar",
            "go_to_order_btn": "Shko te pako ime",
            "back_home": "Kthehu në shtëpi",
            "back_mall": "Kthehu tek qendra tregtare",
            "ordersn_empty": "Rendit SN nuk mund të jetë bosh",
            "order_search_error": "Gabim i papritur",
            "goodsName": 'Emri i produktit'
        },
        "fail": {
            "payment_fail": "Pagesa dështoi",
            "back_home": "Kthehu në shtëpi"
        }
    },
    "CountryGroup": {
        "title": "Vend/rajon",
        "placeholder": "Vendi i kërkimit ose rajoni",
        "clear": "I qartë",
        "history": "Historia e Kërkimit"
    },
    "PromotionCode": {
        "verification": {
            "title": "Kodin e kuponit",
            "minititle": "Kodin e kuponit",
            "input": "Ju lutemi shkruani kodin e sipërm",
            "explain": "Këshilla: Prekni butonin e skanimit në të djathtën e sipërme për të skanuar kodin QR të kartës së kuponit, ose futni manualisht kodin e kuponit (i ndjeshëm në rast) nëse nuk funksionon.",
            "submit": "Paraqes",
            "exchange": "Shpengoj",
            "cancel": "Anuloj",
            "Inquiry": "A jeni i sigurt për të shkëmbyer",
            "ErrorCode": "Gabim i kodit të rimbushjes"
        },
        "recharge_success": {
            "package": "Pako",
            "content": "Shpenguar me sukses",
            "back": "Kthehu tek qendra tregtare",
            "view_packets": "Shko te pako ime"
        }
    },
    "order": {
        "state": {
            "inUse": "I aktivizuar",
            "isFirst": "Me përparësi",
            "toFirst": "Vendosni përparësinë",
            "inactive": "I çaktivizuar",
        },
        "periodUnits": {
            "minute": "minutë (a)",
            "hour": "Ora (S)",
            "day": "Dita (S)",
            "month": "muaji (et)"
        },
        "useIntro": {
            "tip1": "Paketa e pakufizuar e të dhënave ka përparësi më të lartë sesa paketa e të dhënave të vëllimit.",
            "tip2": "Prioriteti i përdorimit do të bazohet në datën e blerjes për të njëjtin lloj pakete, d.m.th., paketa me datën më të hershme të blerjes do të përdoret së pari, ndërsa përparësia e paketave me një rajon është më i lartë se paketa rajonale.",
            "tip3": "Ju gjithashtu mund të rregulloni manualisht përparësinë e përdorimit të paketave të të njëjtit lloj."
        },
        "myFlow": "Të dhënat e mia",
        "remainingFlow": "Të dhënat e mbetura",
        "remainingTime": "E vlefshme e majtë",
        "remainingHighFlow": "Mbetur shpejtë",
        "validPeriod": "Vlefshmëri",
        "noneFlow": "Asnjë paketë e të dhënave",
        "noneFlowTip": "Ju lutemi blini paketën e të dhënave dhe shijoni rrjetin me cilësi të lartë",
        "buyPackFlow": "Bli paketet",
        "checkInvalidFlow": "Kontrolloni paketën e të dhënave të skaduara",
        "orderList": {
            "title": "porositë e mia",
            "amount_paid": "Gjithsej",
            "device": "Pajisja në pronësi",
            "order_details": "Detajet e porosisë",
            "total_amont": "Nëntotali",
            "orderSN": "Urdhri nr.",
            "createTime": "Koha e krijimit",
            "cancelTime": "Koha e mbyllur",
            "payTime": "Ora e porosisë",
            "unsubTime": "Koha e anuluar",
            "payMethod": "Mënyra e pagesës",
            "thirdSN": "Transaksioni nr.",
            "delete": "Fshije",
            "cancel": "Anulo porosinë",
            "unsub": "Rimbursimi",
            "goto_cancel": "Dëshiron ta anulosh porosinë?",
            "goto_unsubscribe": "Dëshiron ta çabonosh porosinë?",
            "delete_Tips": "Porosia nuk mund të rifillojë pasi të jetë fshirë, prandaj problemet tuaja pas shërbimit nuk mund të trajtohen.Je i sigurt që do ta fshish?",
            "status_success": "E përfunduar",
            "status_pending": "E papaguar",
            "status_cancel": "Mbyllur",
            "status_unsub": "Anuluar",
            "payMethod_stripe": "Kartë kredie"
          }
    },
    "registerlogin": {
        "create_account_tip":"Krijoni një llogari, filloni përvojën ekskluzive",
        "select_country_tip":"Pajisja Përdorni vendin/rajonin",
        "email_name": "Postë",
        "phone_name": "Telefon",
        "email_address": "Adresa e postës elektronike",
        "password": "fjalëkalim",
        "country": "vend",
        "select_country": "Zgjidhni një vend",
        "cancel": "Anuloj",
        "confirm": "I sigurt",
        "please_enter": "Ju lutemi shkruani 6-20 karaktere (kombinim i shkronjave, numrave ose simboleve)",
        "select_country_tips": "Përzgjedhja e vendit është për shikimin e paketave lokale. Nuk mund të ndryshohet pas regjistrimit. Ju lutem konfirmoni!",
        "global_roaming": "Kodi Ndërkombëtar i Domainit",
        "phone_number": "numër telefoni",
        "agree": "pajtohem",
        "user_agreement": "Marrëveshja e Përdoruesit",
        "and": "dhe",
        "privacy_policy": "Politika e privatësisë",
        "register_login": "Regjistrohuni ose Hyni",
        "login_error": "Numri i hyrjeve është shumë i shpeshtë, ju lutemi provoni përsëri më vonë!",
        "register_error": "Numri i regjistrimeve është shumë i shpeshtë, ju lutemi provoni përsëri më vonë!",
        "forgot_pwd": "Harrojeni fjalëkalimin",
        "app_tips": "Hyni në aplikacion me këtë llogari pasi ta keni shkarkuar për të hyrë më shumë veçori.",
        "download_app": "Shko për të shkarkuar aplikacionin",
        "rememberPwd": "Mos harroni fjalëkalimin",
        "third_login": "Vazhdoj",
        "agreement_tips": "Ju lutemi kontrolloni Marrëveshjen e Përdoruesit dhe Kutinë e Politikave të Privatësisë",
        "selectCountry_tips": "Ju lutemi vini re me mirësi se vendi i regjistruar do të ndikojë drejtpërdrejt në metodat dhe monedhat e mëposhtme të pagesës, ju lutemi zgjidhni sipas nevojës tuaj.",
        "login_error_cancel": "Përdoruesi anuloi hyrjen",
        "login_error_auth": "Lejoni pop-up nga rregullimet e shfletuesit",
        "device_tips": "Dispozitivi pret aktivizim. Përpunimi brenda 24 orësh."
    },
    "forgotPwd": {
        "forgot_pwd": "Harrojeni fjalëkalimin",
        "email_address": "Adresa e postës elektronike",
        "next": "Tjetër",
        "email_has_been_sent": "Ne kemi dërguar një email në %@email. Ju lutemi klikoni në lidhjen dhe ndiqni hapat për të marrë fjalëkalimin tuaj.",
        "have_retrieved_it": "Unë e kam gjetur atë",
        "unable_to_receive_email": "Nuk mund ta merrni emailin? Ju lutemi kontrolloni nëse ka postë elektronike nga %@email nën spam tuaj dhe drejtoria e postës së fshirë",
        "or": "ose",
        "resend": "Rivendos",
        "global_roaming": "Kodi Ndërkombëtar i Domainit",
        "phone_number": "numër telefoni",
        "verification_code_has_been_sent": "Ne i kemi dërguar kodin e verifikimit në:",
        "verification_code": "Kod verifikimi",
        "no_verification_code_received": "A nuk e mori kodin e verifikimit?",
        "please_enter": "Ju lutemi shkruani 6-20 karaktere (kombinim i shkronjave, numrave ose simboleve)",
        "reset_password": "Rivendosni fjalëkalimin",
        "reset_successful": "Rivendos me sukses"
    },
    "coupons": {
        "coupons_name": "Kuponë",
        "no_coupons": "Ende nuk ka kuponë",
        "no_data": "Ende nuk ka të dhëna",
        "applicable_to_the_following": "Kuponat janë të përshtatshëm për paketën e mëposhtme të të dhënave"
    },
    "digital":{
        "title":"Pajisja SN",
        "purchased":"Blerjet e mia",
        "viewAll":"Më",
        "skinStore":"Dyqan produktesh",
        "completed":"Tregtuar",
        "goBuy":"Blej",
        "order": {
          "title":"Porositë e blera"
        },
        "detail": {
          "describe":"Përshkrim"
        }
    },
    "viewPL": {
        "other": 'tjetër'
    },
    "invalidFlow": {
        "stateName": "Status",
        "state": {
            "NOT_ACTIVATED": "I çaktivizuar",
            "IN_USING": "I disponueshëm",
            "USE_END": "I rraskapitur",
            "EXPIRE": "I skaduar",
            "TRANSFER": "Transfer",
            "UNSUBSCRIBE": "Anuloj",
            "VALID": "I vlefshëm",
            "INVALID": "I pavlefshëm",
            "EXCHANGE_POINTS": "Shlyerja e pikave"
        },
        "noneFlow": "Asnjë paketë e të dhënave e skaduar",
        "pageName": "Paketa e të dhënave e skaduar"
    },
    "flowDetail": {
        "title": "Detajet e të dhënave",
        "flow": "Të dhëna",
        "validTime": "Fillon e vlefshme",
        "invalidTime": "E vlefshme deri në",
        "coverage": "Mbulim",
        "useIntro": "Kushtet dhe kushtet",
        "purchaseTime": "Blerë në",
        "subtotal": "I hollësishëm",
        "status": "Status",
        "cancel": "Anuloj",
        "buyAgain": "Bleni përsëri",
        "validity": "Vlefshmëri",
        "tip": "Njoftim",
        "cancelTip": "A jeni i sigurt që doni të rimbursoni këtë paketë?",
        "dataLeft": "Të dhënat e mbetura"
    },
    "netError": {
        "try_again": "Provo përsëri",
        "net_error": "Asnjë rrjet",
        "try_again_desc": "Ju lutemi kontrolloni cilësimin e rrjetit dhe provoni përsëri"
    },
    "loadFail": {
        "try_again": "Provo përsëri",
        "load_fail": "Ngarkimi dështoi",
        "load_fail_desc": "Ngarkimi i të dhënave dështoi, ju lutemi provoni përsëri",
        "IMEI_Not_Exist": "IMEI nuk ekziston, ju lutemi përpiquni të hyni nga hyrja e duhur",
        "Project_Not_Exist": "Ndodh një gabim. Ju lutemi kontaktoni shërbimin e klientit. (01)",
        "commonError": "Ndodh një gabim. Ju lutemi kontaktoni shërbimin ndaj klientit."
    },
    "settlement_Easy_and_convenient": "E lehtë dhe e përshtatshme",
    "settlement_Great_deal": "Shumë",
    "settlement_Safe_and_secure": "I sigurt dhe i sigurt",
    "settlement_Autopay_service_regulation": "Rregullorja e Shërbimit Autopay",
    "settlement_Read": "Lexoj",
    "settlement_No_coupon": "Asnjë kupon i disponueshëm",
    "settlement_Subtotal": "I hollësishëm",
    "settlement_Coupon": "Kupon",
    "settlement_TOTAL": "I plotë",
    "settlement_promotion_tip": "Oferta promovuese nuk mund të përdoret në lidhje me ndonjë kupon",
    "settlement_coupon_tip": "Kuponi nuk mund të përdoret në lidhje me ndonjë ofertë tjetër promovuese",
    "member_myFlow_noList": "Asnjë të dhënë",
    "detail_se_content": "Një mënyrë e sigurt, e lehtë dhe e përshtatshme. Ju mund të çabonoheni në çdo kohë",
    "Enter_Promo_code": "Kod promovimi",
    "Enter_Promo_Coupon": "Kuponë",
    "settlement_Not_used_coupon": "Kupon nuk përdoret",
    "settlement_Available_coupon": "I disponueshëm",
    "settlement_Unavailable_coupon": "I padisponueshëm",
    "please_Enter_Promo_code": "Ju lutemi shkruani kodin e promovimit",
    "please_Select_Coupon_use": "Ju lutemi zgjidhni kuponin që dëshironi të përdorni.",
    "Buy_Now": "Blej tani",
    "Dont_Use_Any": "Mos përdorni asnjë",
    "settlement_confirm": "Konfirmoj",
    "settlement_tips": "Konfirmoj",
    "flowDetail_unsubscribe": "Çabonohem",
    "flowDetail_unsubscribed": "I paprishur",
    "flowDetail_isCancelPackage": "Çabonohuni këtë paketë?",
    "flowDetail_confirmAgreementUnsubscribe": "Ju nuk mund të keni një pjesë të madhe pasi të mos abonoheni. A jeni i sigurt që doni të çabonoheni?",
    "flowDetail_cancel": "Anuloj",
    "flowDetail_cancelSuccess": "Çabonohuni me sukses",
    "packages_detail_promotion": "Promovim",
    "orderTips":{
        "iDay" : "ditë",
        "iDays" : "ditë",
        "iMonth" : "muaj",
        "iMonths" : "muaj",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Në blerjen tuaj të parë, Paguaj %@money/%@periodSymbol më vonë, Ju mund të çabonoheni në çdo kohë",
        'Monthly_discount':"Kurseni %@saveMoney secila %@period! Ju mund të çabonoheni në çdo kohë",
        'Ordinary_monthly_package':"Një mënyrë e sigurt, e lehtë dhe e përshtatshme. Ju mund të çabonoheni në çdo kohë",
        "AlreadyPurchased":'Na vjen keq që mund të regjistroheni vetëm në një paketë të të dhënave për momentin. Ju lutemi çregjistrohuni nga “%@” dhe pajtohuni më vonë në çdo paketë që dëshironi pasi të skadojë.',
        "Contract_recommendation_First":'<label>Me shërbimin autopay, në blerjen tuaj të parë, paguani vetëm</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Ju mund të çabonoheni në çdo kohë'
        +'<a class="btn">Pajtohem ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Me shërbimin autopay, paguani vetëm</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Ju mund të çabonoheni në çdo kohë'
        +'<a class="btn">Pajtohem ></a></p>',
        "Contract_recommendation_General":"<label>Me Shërbimin Autopay</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Një mënyrë e sigurt, e lehtë dhe e përshtatshme. Ju mund të çabonoheni në çdo kohë'
        +'<a href="javascript:;" class="btn">Pajtohem ></a></p>',
        'BanlanceDoubleCheck':'A jeni i sigurt që doni të paguani me bilanc?',
    },
    feedback: {
        title: "reagime",
        placeholder: "Ju lutemi hyni në vendin që dëshironi të vizitoni ose ndonjë pyetje tjetër, dhe ne do t'i plotësojmë nevojat tuaja sa më shpejt të jetë e mundur!",
        submit: "Paraqes",
        submit_success: "Dërgimi me sukses",
        other_opinions: "Mendime të tjera",
    },
    view_country_input: 'Ju lutemi shkruani llogarinë tuaj',
    "select_package": {
        "title": "Zgjidh të dhënat",
        "allPackage": "Të gjitha të dhënat",
        "type": "Tip",
        "flow": "të dhënat",
        "month_package": "Plan Muajsh",
        "flow_package": "Paket të Dhënave",
        "time": "Kohëzgjatja",
        "period": "Cikli",
        "auto_debit": "Info Debit Automatik",
        "auto_subscribe": "Auto-Rishikim",
        "detail": "Detajet e të Dhënave",
        "carrier": "Operatoret e Mbështetura",
        "country": "Vende Mbuluar",
        "notice": "Gjuia e Blerjes"
    }
}